import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { AxiosError } from 'axios'

import axios from '../lib/axios'

export type UseRequestBlobParams = {
  url: string
  postBody?: any
  method?: 'POST' | 'GET'
}
const requestBlob = async ({
  url,
  postBody = {},
  method = 'POST',
}: UseRequestBlobParams): Promise<Blob> => {
  const { data } = await axios.request<Blob>({
    method,
    url,
    data: postBody,
    responseType: 'blob',
  })

  return data
}

export const useRequestBlob = (
  options?: UseMutationOptions<Blob, AxiosError, UseRequestBlobParams, unknown>,
): UseMutationResult<Blob, unknown, UseRequestBlobParams, unknown> => {
  return useMutation({
    mutationFn: requestBlob,
    ...options,
  })
}

export const downLoadReceivedBlob = ({
  blob,
  name,
}: {
  blob: Blob
  name: string
}): void => {
  const url = window.URL.createObjectURL(new Blob([blob]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
  link?.parentNode?.removeChild(link)
}
